import { ZIndex } from "@mui/material";

const zIndex: ZIndex = {
  layout: {
    hidden: -1,
    visible: 0,
    default: 1,
    active: 2,
  },
  components: {
    table: {
      head: {
        sticky: 3,
        default: 4,
      },
    },
    pdfViewer: {
      comment: {
        default: 1,
        active: 2,
      },
      page: 3,
      toolbar: 4,
      highlight: 3,
      filter: 5,
    },
    question: {
      header: 1000,
    },
    section: {
      expanded: 3,
    },
    globalNavigation: 1210,
  },
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500,
};

export default zIndex;
